/**
 * Subjects where `assignedTeacherId` matches the teacher document id (`id` or `authUid`).
 * Missing `isDelete` on teacher is unrelated — this is subject → teacher link only.
 */
export function getSubjectsAssignedToTeacher(teacherId, subjects) {
    if (!teacherId) return [];
    const tid = String(teacherId);
    return (subjects || []).filter((s) => s?.assignedTeacherId != null && String(s.assignedTeacherId) === tid);
}

export function formatSubjectAssignmentList(rows, { max = 12 } = {}) {
    const list = (rows || []).slice(0, max).map((s) => {
        const name = (s?.name || '').trim() || 'Subject';
        const code = (s?.code || '').trim();
        return code ? `${name} (${code})` : name;
    });
    const more = (rows || []).length > max ? `\n… and ${rows.length - max} more` : '';
    return list.join(', ') + more;
}
